import LoginPage from './LoginPage';
export default LoginPage;


// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/login/index.js